import './App.css';

import { useEffect, useState } from 'react';
import Header from "./components/Header";
import ElementDisplay from "./components/ElementDisplay";
import SideBar from "./components/SideBar";
import database from './temp.json';

import { db } from './Firebase';
import { collection, getDocs } from "firebase/firestore";
import { getDataByCode, getDataByID, modularObj, orderList } from './functions';
import ActionButtons from './components/ActionButtons';
import LoadingScreen from './components/ui/LoadingScreen';
import { useTranslation } from 'react-i18next';

// import ActionButtons from "./components/ActionButtons";
// import Footer from "./components/Footer";

const version = "1.0.3";

export default function App() {
  const { i18n, t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const [zeCollection, setZeCollection] = useState();
  const [iframe, setIframe] = useState();
  const [currModel, setCurrModel] = useState({});
  const [isBothMode, setIsBothMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [modDirection, setModDirection] = useState();

  const [dimensions, setDimensions] = useState(false);

  const [allModels, setAllModels] = useState([]);

  const [activeTab, setActiveTab] = useState("")


  const [data, setData] = useState(database); // FOR TESTING

  // const fabricOptions = [
  //   { name: "Collection 1", image: "collection1.jpg" },
  //   { name: "Collection 2", image: "collection2.jpg" },
  //   { name: "Collection 3", image: "collection3.jpg" },
  //   // Add more options here
  // ];

  // const handleFabricSelect = (fabric) => {
  //   console.log("Selected Fabric:", fabric);
  // };

  /*-------------------------------------------------------- Fetch data from DATABASE --------------------------------------------------------*/
  // const collections = ["collections","components"];
  // const fetchPost = async () => {
  //   for (let col of collections) {
  //     await getDocs(collection(db, col))
  //       .then((querySnapshot) => {
  //         const newData = querySnapshot.docs
  //           .map((doc) => {
  //             const docData = doc.data();
  //             // Exclure les champs spécifiques
  //             const { createdby, createdate, lastupdate, updatedby, ...filteredData } = docData;
  //             return { ...filteredData, id: doc.id };
  //           });
  //         setData(zeData => ({ ...zeData, [col]: newData }));
  //         // console.log(data, newData);
  //       })
  //   }
  // }

  // useEffect(() => {
  //   fetchPost();
  // }, [])
  /* END --------------------------------------------------- Fetch data from DATABASE --------------------------------------------------- END */

  useEffect(() => {
    // console.log(data)
    if (data?.components) {
      setZeCollection(getDataByCode(data, "collections", urlParams.get("collection")))
      urlParams.get('lang') && i18n.changeLanguage(urlParams.get('lang'));
      urlParams.get('menu') && setActiveTab(urlParams.get('menu'));
    }
  }, [data])

  useEffect(() => {
    let isMod;
    if (zeCollection) {
      let tmp = [];
      for (let m of zeCollection.models) {
        // console.log(m)
        const mod = getDataByID(data, "components", m);
        tmp.push(mod.type);
      }
      isMod = tmp.includes("mod");
      if (isMod) {
        setCurrModel(modularObj)
        setIsBothMode(true)
      }
      // Set all models
      let models = [];
      for (let m of zeCollection.models) {
        const goodModel = getDataByID(data, "components", m);
        models.push(goodModel)
      }
      // console.log(models)
      models.sort((a, b) => orderList.indexOf(a.code) - orderList.indexOf(b.code));
      if (isMod) {
        models.unshift(modularObj)
      }
      setAllModels(models)
    }

  }, [zeCollection])

  function AddPressed(e) {
    const el = e.detail
    setPopup(true)
    setModDirection(el);
  }
  function AppReady() {
    //On start
    // console.log(zeCollection.startMode )
    iframe.database = data;
    if (zeCollection.startMode === "std") {
      const modelCode = "sofa";
      setCurrModel(getDataByCode(data, "components", modelCode))
      iframe.setViewerModel(modelCode)
    }
  }

  function LostFocus() {
    setActiveTab("")
  }

  function onLoadingBegin() {
    setIsLoading(true)
  }

  function onLoadingEnd() {
    setIsLoading(false)
  }

  useEffect(() => {
    if (iframe) {
      iframe.addEventListener("AddPressed", AddPressed, false);
      iframe.addEventListener("AppReady", AppReady, false);
      iframe.addEventListener("LostFocus", LostFocus, false);
      iframe.addEventListener("onLoadingBegin", onLoadingBegin, false);
      iframe.addEventListener("onLoadingEnd", onLoadingEnd, false);
    }
    return () => {
      if (iframe) {
        iframe.removeEventListener("AddPressed", AddPressed);
        iframe.removeEventListener("AppReady", AppReady);
        iframe.removeEventListener("LostFocus", LostFocus);
        iframe.removeEventListener("onLoadingBegin", onLoadingBegin);
        iframe.removeEventListener("onLoadingEnd", onLoadingEnd);
      }
    }
  }, [iframe]);

  // POPUP
  const [popup, setPopup] = useState(false);
  const [selElement, setSelElement] = useState(false);

  return (
    <>
      {zeCollection ? <div className="relative w-full h-screen bg-white overflow-hidden">
        {isLoading && <LoadingScreen />}
        <Header collection={zeCollection} />
        <div className='w-full h-full flex flex-row justify-end font-NeueMTL'>
          <ElementDisplay
            db={data}
            collection={zeCollection}
            popup={popup}
            setPopup={setPopup}
            selElement={selElement}
            setSelElement={setSelElement}
            allModels={allModels}
            iframe={iframe}
            modDirection={modDirection}
          />
          <SideBar
            allModels={allModels}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isBothMode={isBothMode}
            currModel={currModel}
            setCurrModel={setCurrModel}
            db={data}
            iframe={iframe}
            collection={zeCollection}
          />
          <ActionButtons collection={zeCollection} dimensions={dimensions} setDimensions={setDimensions} iframe={iframe} />
          <iframe className='fixed h-full w-full z-[1]' onLoad={(e) => setIframe(e.target.contentWindow)} src={'./app/v' + version + '/index.html?collection=' + zeCollection.code} />
        </div>
        {/* <Footer /> */}
      </div> :
        <LoadingScreen />
      }
    </>
  );
}
